import { Printer, FileText, LayoutList } from "lucide-react";
import { Card, FieldLabel, TextField, ToggleTile, Segmented } from "./controls";
import { PrinterTypeSelector } from "./PrinterTypeSelector";
import { LogoField } from "./LogoField";
import { ReceiptTextStyles } from "./ReceiptTextStyles";

const SIZE_OPTS = [
  { value: "small", label: "Pequeño" },
  { value: "medium", label: "Mediano" },
  { value: "large", label: "Grande" },
];

export const ReceiptTab = ({ s, setS }) => {
  const set = (k) => (v) => setS({ ...s, [k]: v });
  const on = (k) => s[k] ?? true;

  return (
    <div className="space-y-6">
      <Card icon={Printer} title="Impresora y papel" subtitle="Cómo y dónde se imprime el ticket" testId="settings-card-printer">
        <PrinterTypeSelector />
        <div>
          <FieldLabel title="Tamaño del papel" hint="Ancho de la impresora térmica del recibo" />
          <Segmented options={[{ value: "58mm", label: "58mm" }, { value: "80mm", label: "80mm" }]} value={s.receipt_paper_size} onChange={set("receipt_paper_size")} testIdPrefix="settings-paper" />
        </div>
      </Card>

      <Card icon={FileText} iconClass="text-slate-700" title="Encabezado y pie" subtitle="Marca, logo y mensajes del ticket" testId="settings-card-texts">
        <TextField title="Nombre en el recibo" hint="Cabecera del ticket" value={s.receipt_business_name} onChange={set("receipt_business_name")} placeholder="Ej: Banca La Suerte" maxLength={60} testId="settings-business-name" />
        <LogoField s={s} setS={setS} />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <ToggleTile title="Mostrar logo" hint="Imprime el logo arriba" checked={on("receipt_show_logo")} onChange={set("receipt_show_logo")} testId="settings-show-logo" />
          <div>
            <FieldLabel title="Tamaño del logo" />
            <Segmented small options={SIZE_OPTS} value={s.receipt_logo_size || "medium"} onChange={set("receipt_logo_size")} testIdPrefix="settings-logo-size" />
          </div>
        </div>
        <TextField title="Eslogan (debajo del nombre)" hint="Ej: Solidez y garantía" value={s.receipt_footer_line1} onChange={set("receipt_footer_line1")} testId="settings-footer-1" />
        <TextField title="Título de la venta" hint="Vacío = no se imprime" value={s.receipt_title_text ?? "VENTA DE LOTERIA"} onChange={set("receipt_title_text")} maxLength={40} testId="settings-title-text" />
        <TextField title="Pie línea 1" hint="Encima del QR (vacío = REVISE SU TICKET)" value={s.receipt_footer_line2} onChange={set("receipt_footer_line2")} placeholder="REVISE SU TICKET" mono testId="settings-footer-2" />
        <TextField title="Pie línea 2" value={s.receipt_footer_line3} onChange={set("receipt_footer_line3")} placeholder="Buena Suerte en sus Jugadas!" testId="settings-footer-3" />
        <TextField title="Sitio web / URL" hint="Aparece en mayúsculas al final" value={s.receipt_website} onChange={set("receipt_website")} placeholder="MIBANCA.COM" mono testId="settings-website" />
      </Card>

      <Card icon={LayoutList} iconClass="text-slate-700" title="Contenido del ticket" subtitle="Elige qué datos se imprimen" testId="settings-card-content">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <ToggleTile title="Serial" hint="Sucursal-cajero" checked={on("receipt_show_serial")} onChange={set("receipt_show_serial")} testId="settings-show-serial" />
          <ToggleTile title="Código No" hint="Código de verificación" checked={on("receipt_show_code")} onChange={set("receipt_show_code")} testId="settings-show-code" />
          <ToggleTile title="Leyenda de loterías" hint="Ln -> LEIDSA Noche" checked={on("receipt_show_legend")} onChange={set("receipt_show_legend")} testId="settings-show-legend" />
          <ToggleTile title="Sello ** COPIA **" hint="En reimpresiones" checked={on("receipt_show_copy_mark")} onChange={set("receipt_show_copy_mark")} testId="settings-show-copy" />
          <ToggleTile title="Código QR" hint="Para verificar y pagar" checked={on("receipt_show_qr")} onChange={set("receipt_show_qr")} testId="settings-show-qr" />
          <div>
            <FieldLabel title="Tamaño del QR" />
            <Segmented small options={SIZE_OPTS} value={s.receipt_qr_size || "medium"} onChange={set("receipt_qr_size")} testIdPrefix="settings-qr-size" />
          </div>
        </div>
      </Card>

      <ReceiptTextStyles s={s} setS={setS} />
    </div>
  );
};
